'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _InputField = require('./InputField');

var _InputField2 = _interopRequireDefault(_InputField);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var InputInset = function InputInset(props) {
  var insetLeft = props.insetLeft,
      insetRight = props.insetRight;

  var insetClassNames = (0, _classnames2.default)('luna-inset', {
    'luna-inset--left': insetLeft,
    'luna-inset--right': insetRight
  });
  return _react2.default.createElement(
    'div',
    { className: insetClassNames },
    _react2.default.createElement(_InputField2.default, props),
    insetLeft ? insetLeft : insetRight
  );
};

exports.default = InputInset;


// WEBPACK FOOTER //
// ./node_modules/luna-react/dist/components/Input/InputInset.js